'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import * as customWidgetEditorOptionsSelectors from 'DesignData/selectors/customWidgetEditorOptions';
import Sidebar from 'DesignEditorsUI/components/customWidgetEditor/sidebar/Sidebar';

function makeMapStateToProps() {
  return (state, props) => {
    return {
      customWidgetId: props.customWidgetId,
      isSelectingIcon: customWidgetEditorOptionsSelectors.getIsSelectingIcon(state, props),
      selectedField: customWidgetEditorOptionsSelectors.getSelectedField(state, props)
    };
  };
}

class SidebarContainer extends Component {
  render() {
    const {
      customWidgetId,
      isSelectingIcon,
      selectedField,
      revisionId
    } = this.props;
    return /*#__PURE__*/_jsx(Sidebar, {
      customWidgetId: customWidgetId,
      revisionId: revisionId,
      isSelectingIcon: isSelectingIcon,
      selectedField: selectedField
    });
  }

}

SidebarContainer.propTypes = {
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  isSelectingIcon: PropTypes.bool.isRequired,
  selectedField: PropTypes.object.isRequired,
  revisionId: PropTypes.number
};
export default connect(makeMapStateToProps, {})(SidebarContainer);